import { useState, useEffect } from "react";
import axios from "axios";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import {} from "react-router-dom";
import "../style/default.css";
import "../style/home.css";
import lalamove from "../assets/lalamove.png";
import grab from "../assets/grab.png";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import sample_prod from "../assets/products/35mm_film_colorprints_lab_template.jpg";

function ShowProducts(props) {
  const baseURL = process.env.REACT_APP_BASE_URL;

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const value = queryParams.get("keyword");
  const search = queryParams.get("search");
  const collect_name = queryParams.get("collect");
  const collection = queryParams.get("page");
  const sortBy = queryParams.get("sortBy");
  const [isLoading, setIsLoading] = useState(true);
  const [parameters, setParameters] = useSearchParams();
  const [product, setProducts] = useState([]);

  useEffect(() => {
    try {
      setIsLoading(true);
      if (value) {
        axios
          .get(`${baseURL}/catalogue`, {
            params: {
              keyword: value,
              sortBy: props.param,
            },
            responseType: "json", // Assuming the server response is in JSON format
          })
          .then((res) => res.data)
          .then((data) => {
            const prod = data.map((product) => product);
            props.setProdCount(prod.length);
            setProducts(prod);
          })
          .catch((error) => {
            console.error("Error fetching the products:", error);
          });
      }

      if (search) {
        axios
          .get(`${baseURL}/search`, {
            params: {
              keyword: search,
              sortBy: props.param,
            },
            responseType: "json", // Assuming the server response is in JSON format
          })
          .then((res) => res.data)
          .then((data) => {
            const prod = data.map((product) => product);
            props.setProdCount(prod.length);
            setProducts(prod);
          })
          .catch((error) => {
            console.error("Error fetching the products:", error);
          });
      }

      if (collection) {
        axios
          .get(`${baseURL}/collect`, {
            params: {
              keyword: collection,
              sortBy: props.param,
            },
            responseType: "json", // Assuming the server response is in JSON format
          })
          .then((res) => res.data)
          .then((data) => {
            const prod = data.map((product) => product);
            props.setProdCount(prod.length);
            setProducts(prod);
          })
          .catch((error) => {
            console.error("Error fetching the products:", error);
          });
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [parameters]);

  const photoStyle = {
    width: "100%",
    objectFit: "cover",
    margin: "5px",
  };
  if (isLoading) {
    return <div>No Products Found! </div>;
  }

  return (
    <div className="ShowProducts">
      <h1>{props.header}</h1>
      {/* New Items, */}

      <div className="products">
        <div className="products_grid">
          {product.map((product, index) => (
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <Link
                to={`/product/${product.prod_id}`}
                style={{ textDecoration: "none" }}
              >
                {" "}
                <div className="prod-img">
                  {product.prod_stock <= 0 ? (
                    <img
                      key={index}
                      src={JSON.parse(product.prod_image)[0]}
                      alt={`Photo ${index}`}
                      style={{ photoStyle, opacity: "0.5" }}
                    />
                  ) : (
                    <img
                      key={index}
                      src={JSON.parse(product.prod_image)[0]}
                      alt={`Photo ${index}`}
                      style={photoStyle}
                    />
                  )}
                </div>
              </Link>

              {product.prod_preorder == "yes" ? (
                <div className="prod-tag">
                  <i>
                    {" "}
                    <Chip
                      label="Pre-Order"
                      size="small"
                      color="warning"
                      style={{ color: "#fff" }}
                    />
                  </i>
                </div>
              ) : (
                ""
              )}

              <span>
                <span>{product.prod_name}</span>
                <br />
                {product.prod_sale > 0 ? (
                  <span>
                    <strike>
                      <b>₱{product.prod_price}</b>
                    </strike>{" "}
                    <b style={{ color: "red" }}>₱{product.prod_sale} Sale</b>
                  </span>
                ) : product.prod_stock <= 0 ? (
                  <span>
                    <strike>
                      <b>₱{product.prod_price}</b>
                    </strike>{" "}
                  </span>
                ) : (
                  <b>₱{product.prod_price}</b>
                )}
                <br />
                {product.prod_stock <= 0 ? (
                  <i>
                    {" "}
                    <Chip
                      label="Sold Out"
                      size="small"
                      color="error"
                      style={{ color: "#fff" }}
                    />
                  </i>
                ) : product.prod_stock === "yes" ? (
                  <i>
                    {" "}
                    <Chip
                      label="Limited Stock"
                      size="small"
                      color="error"
                      style={{ color: "#fff" }}
                    />
                  </i>
                ) : (
                  ""
                )}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ShowProducts;
